<div class="event-filter-wrapper" [class.topbar-filter]="mode==='topbar'">
    <div class="event-date-filter-wrapper" [ngStyle]="{'flex':mode==='topbar'?'4':'1'}">
        <ig-accordion #eventDateAccordion id="event-filter-date" class="select-date-panel top-bar-font-size"
            title="FILTER BY DATE" (onClearFilter)="filterEvents(null, 'allDates')">
            <div item (click)="filterEvents(null, 'allDates')"
                [ngClass]="{'selected':command.queryCommand.dateFilterText===null||command.queryCommand.dateFilterText==='FILTER BY DATE'}"
                id="allDates">
                ALL
            </div>
            <div item (click)="filterEvents(null, 'Today')"
                [ngClass]="{'selected':command.queryCommand.dateFilterText==='Today'}">
                TODAY
            </div>
            <div item (click)="filterEvents(null, 'Tomorrow')"
                [ngClass]="{'selected':command.queryCommand.dateFilterText==='Tomorrow'}">
                TOMORROW
            </div>
            <div item (click)="filterEvents(null, 'This Week')"
                [ngClass]="{'selected':command.queryCommand.dateFilterText==='This Week'}" id="this weekend">
                THIS WEEK
            </div>
            <div item (click)="filterEvents(null, 'This Weekend')"
                [ngClass]="{'selected':command.queryCommand.dateFilterText==='This Weekend'}">
                THIS WEEKEND
            </div>
            <div item (click)="filterEvents($event, 'showSpecificDates')"
                [ngClass]="{'selected':command.queryCommand.dateFilterText==='Specific Dates'}">
                SELECT SPECIFIC DATES
            </div>
            <div item class="time-range" *ngIf="isFilteringBySpecificDates">
                <ng-container class="date">
                    <ig-date-field #from tabindex="0" (keypress)="onDateFieldKeyPress($event, 'from')" label="from"
                        [(ngModel)]="fromForSelector" [max]="toForSelector">
                    </ig-date-field>
                </ng-container>
                <ng-container class="date">
                    <ig-date-field #to tabindex="0" (keypress)="onDateFieldKeyPress($event, 'to')" label="to"
                        [(ngModel)]="toForSelector" [min]="fromForSelector">
                    </ig-date-field>
                </ng-container>
                <ig-button size="md" (trigger)="filterEvents(null, 'Specific Dates')">search</ig-button>
            </div>
        </ig-accordion>
    </div>

    <div [ngStyle]="{'flex':mode==='topbar'?'4':'1'}">
        <ig-accordion #customEventAccordion id="event-filter-custom" title="EVENT CATEGORIES" class="top-bar-font-size"
            [maxHeight]="400" (onClearFilter)="getFeedEvent({sourceType: 'all'})">
            <div item [class.selected]="!selectedCustomEvent&&!command.queryCommand.choice"
                (click)="getFeedEvent({sourceType: 'all'})">
                ALL EVENTS
            </div>
            <div item *ngIf="!isHideEditorChoice&&editorChoiceText" [class.selected]="command.queryCommand.choice"
                (click)="editChoice()">
                {{editorChoiceText}}
                <mat-icon>favorite</mat-icon>
            </div>
            <div item *ngFor="let customevent of customEvents"
                [class.selected]="selectedCustomEvent?._id===customevent._id" (click)="getFeedEvent(customevent)">
                <span>{{customevent.btnText}}</span>
            </div>
        </ig-accordion>
    </div>
</div>


// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/components/visitor/event.filter/event.filter.component.html